export default function iframeSandboxDomainStrategy(metaSiteId, experiments) {
    var _a;
    const iframeSandboxDomainParams = {};
    if (metaSiteId) {
        const host = ((_a = experiments === null || experiments === void 0 ? void 0 : experiments.iframeSandboxSecondaryHost) === null || _a === void 0 ? void 0 : _a.enabled) ? 'usrfiles' : 'filesusr';
        iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
    }
    return iframeSandboxDomainParams;
}
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map